
import React, { useContext } from 'react'
import SbEditable from 'storyblok-react'
import Label from 'src/components/Label'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import Wave from 'src/utils/Wave'
import GetSettings from 'src/utils/GetSettings'
import { PageContext } from "src/utils/context"

const ContentSplitFourColumn = ({blok}) => {

    const { location } = useContext(PageContext)

    const settings = GetSettings(location)

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                {blok.curve_position === 'top' && <Wave size="small" flip className="fill-blue"/>}
                <div className={`py-12 px-6 bg-blue`}>
                    <div className="max-w-7xl mx-auto 2xl:max-w-screen-2xl">
                        <Heading size="h4" className="text-white font-semibold lg:hidden md:block hidden">Get in touch</Heading>
                        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-20 text-white">
                            <Heading size="h4" className="text-white font-semibold lg:block md:hidden block">Get in touch</Heading>
                            <div>
                                <Label className="text-teal">Direct contact</Label>
                                <a href={`mailto:${settings.email}`} className="block tracking-[-0.01em] text-sm hover:text-teal duration-300">{settings.email}</a>
                                <a href={`tel:${settings.telephone_number}`} className="block tracking-[-0.01em] text-sm hover:text-teal duration-300">{settings.telephone_number}</a>
                            </div>
                            <div>
                                <Label className="text-teal">Address</Label>
                                <span className="block tracking-[-0.01em] text-sm max-w-[170px]">{settings.address}</span>
                                <a 
                                    href={'https://goo.gl/maps/ojjS1Y3Qjc3NEgFH6'}
                                    target='_blank'
                                    rel="noreferrer"
                                    className="text-sm tracking-[-0.01em] hover:text-teal duration-300"
                                >
                                    Open in <span className="font-bold">Google Maps</span>
                                </a>
                            </div>
                            <div>
                                <Label className="text-teal">Opening Hours</Label>
                                <div className="block tracking-[-0.01em] text-sm max-w-[170px]">
                                    <RichText>{settings.opening_hours}</RichText>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {blok.curve_position === 'bottom' && <Wave size="small" className="fill-blue"/>}
            </div>
      </SbEditable>
    )
  };

export default ContentSplitFourColumn